module.exports = __webpack_public_path__ + "static/media/email-icon.e780af76.svg";